import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCard } from '@angular/material/card';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';

@Component({
  selector: 'ui-product-card-small-skeleton',
  imports: [
    NgxSkeletonLoaderComponent,
    MatCard,
  ],
  templateUrl: './product-card-small-skeleton.component.html',
  styleUrls: ['./product-card-small-skeleton.component.scss', '../product-card-small.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardSmallSkeletonComponent {
}
